import axios from 'axios';
import { getFBAuth } from '@/helpers/firebase/services';


let FBEnv = 'dev';
if (process.env.VUE_APP_MODE === 'production') FBEnv = 'production';

const URLAddBuyer = `https://autodrop-${FBEnv}.appspot.com/addBuyer`;
const URLEditBuyer = `https://autodrop-${FBEnv}.appspot.com/modifyBuyer`;
const URLCollectEmailAddress = `https://autodrop-${FBEnv}.appspot.com/addNewLead`;
const URLGetBuyerGroups = `https://autodrop-${FBEnv}.appspot.com/getBuyerGroups`;
const URLPlaceBid = `https://autodrop-${FBEnv}.appspot.com/placeBid`;
const URLSendVehicleToOnline = `https://autodrop-${FBEnv}.appspot.com/sendVehicleToOnline`;
const URLCollectAnalytics = `https://us-central1-autodrop-${FBEnv}.cloudfunctions.net/collectAnalytics`;

const defaultConfig = {
  headers: {
    'Content-Type': 'application/json',
  },
  responseType: 'json',
};

async function getRequestConfig(setAuthorizationHeader = false, acceptLanguageHeader = 'de') {
  const requestConfig = defaultConfig;

  if (setAuthorizationHeader) {
    const FBAuth = await getFBAuth();
    const authToken = await FBAuth.currentUser.getIdToken();

    requestConfig.headers.Authorization = `Bearer ${authToken}`;
  }

  requestConfig.headers['Accept-Language'] = acceptLanguageHeader;

  return requestConfig;
}

export async function APIAddBuyer(buyer, languageCode) {
  const requestConfig = await getRequestConfig(true, languageCode);
  return axios.post(URLAddBuyer, { ...buyer }, requestConfig);
}

export async function APIEditBuyer(buyer, languageCode) {
  const requestConfig = await getRequestConfig(true, languageCode);
  return axios.post(URLEditBuyer, { ...buyer }, requestConfig);
}

export async function APIAddEmailAddress(name, companyName, phone, countryCode, email, isBuyer, isSeller) {
  return axios.post(URLCollectEmailAddress, {
    name,
    companyName,
    phoneNumber: phone,
    countryCode,
    emailAddress: email,
    isBuyer,
    isSeller,
  });
}

export async function APIGetBuyerGroups(languageCode) {
  const requestConfig = await getRequestConfig(true, languageCode);

  return axios.post(URLGetBuyerGroups, {}, requestConfig);
}

export async function APIPlaceBid({
  vehicleId, buyerId, amount, languageCode,
}) {
  const requestConfig = await getRequestConfig(false, languageCode);

  return axios.post(URLPlaceBid, { vehicleId, buyerId, amount: Number.parseInt(amount, 10) }, requestConfig);
}

export async function APISendVehicleToOnline(vehicleId, languageCode) {
  const requestConfig = await getRequestConfig(true, languageCode);

  return axios.post(URLSendVehicleToOnline, { vehicleId }, requestConfig);
}

export async function APICollectAnalytics(pageDetails) {
  return axios.post(URLCollectAnalytics, {
    v: pageDetails.version, // version
    cid: pageDetails.buyerId, // buyer id
    vid: pageDetails.vehicleId, // vehicle id
    t: pageDetails.hitType, // hit type
    dh: pageDetails.hostname, // hostname
    dp: pageDetails.pageURL, // page url
    dt: pageDetails.pageTitle, // page title
  });
}
